<mat-stepper #stepper class="ai-uses" [animationDuration]="0">
    <mat-step class="step-search">
        <ng-template matStepLabel>Search by Client Name or Engagement ID</ng-template>
        <div class="htu-step search">
            <div class="step-img-block">
                <img src="/assets/images/ui-uplift-icons/luca/how-to-use/info-bg-search.jpg" alt="">
            </div>
            <div class="step-info-block card arrow-top">
                <div class="bot-logo">
                    <img src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
                </div>
                <div class="flexbox-column gap-4 step-right-block">
                    <h5 class="title">Search by Client Name or Engagement ID</h5>
                    <div class="flexbox-column gap-8 right-block-inner">
                        <ul class="flexbx-column gap-4 ps-3">
                            <li>Start any session by selecting the relevant engagement.</li>
                            <li>Use the "Search by Client Name" or "Engagement ID" feature to quickly locate client records.</li>
                            <li>Easily access essential project details and information.</li>
                        </ul>
                    </div>
                    <div class="button-group justify-content-end gap-8 mt-3">
                        <button mat-button mat-flat-button color="secondary" class="button-small" (click)="finish()">
                            Skip & Close
                        </button>
                        <button mat-button mat-flat-button color="primary" class="button-small" matStepperNext>Next</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step class="step-chat">
        <ng-template matStepLabel>Start a New Conversation</ng-template>
        <div class="htu-step chat">
            <div class="step-img-block">
                <img src="/assets/images/ui-uplift-icons/luca/how-to-use/info-bg-chat.jpg" alt="">
            </div>
            <div class="step-info-block card arrow-top">
                <div class="bot-logo">
                    <img src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
                </div>
                <div class="flexbox-column gap-4 step-right-block">
                    <h5 class="title">Start a New Conversation</h5>
                    <div class="flexbox-column gap-8 right-block-inner">
                        <ul class="flexbox-column gap-4 ps-3">
                            <li>Start a new conversation with Luca, your AI Preparer.</li>
                            <li>Enjoy natural and intuitive guidance & navigate through complex tasks & workflow with ease and efficiency.</li>
                            <li>Just ask, and Luca will help make your engagement process smoother.</li>
                        </ul>
                    </div>
                    <div class="button-group justify-content-end gap-8 mt-3">
                        <button mat-button mat-stroked-button color="dark" class="button-small" matStepperPrevious>Back</button>
                        <button mat-button mat-flat-button color="secondary" class="button-small" (click)="finish()">
                            Skip & Close
                        </button>
                        <button mat-button mat-flat-button color="primary" class="button-small" matStepperNext>Next</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step class="step-prompts">
        <ng-template matStepLabel>Supercharge your Workflow with Prompts</ng-template>
        <div class="htu-step prompts">
            <div class="step-img-block">
                <img src="/assets/images/ui-uplift-icons/luca/how-to-use/info-bg-prompts.jpg" alt="">
            </div>
            <div class="step-info-block card arrow-bottom">
                <div class="bot-logo">
                    <img src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
                </div>
                <div class="flexbox-column gap-4 step-right-block">
                    <h5 class="title">Supercharge your Workflow with Prompts</h5>
                    <div class="flexbox-column gap-8 right-block-inner">
                        <ul class="flexbox-column gap-4 ps-3">
                            <li>Luca provides smart prompts to streamline your workflow.</li>
                            <li>Guides you through tasks like reconciling accounts or preparing working papers.</li>
                            <li>Saves time and ensures accuracy, tailored to your needs.</li>
                        </ul>
                    </div>
                    <div class="button-group justify-content-end gap-8 mt-3">
                        <button mat-button mat-stroked-button color="dark" class="button-small" matStepperPrevious>Back</button>
                        <button mat-button mat-flat-button color="secondary" class="button-small" (click)="finish()">
                            Skip & Close
                        </button>
                        <button mat-button mat-flat-button color="primary" class="button-small" matStepperNext>Next</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step class="step-documents">
        <ng-template matStepLabel>Drop your Docs with Luca</ng-template>
        <div class="htu-step documents">
            <div class="step-img-block">
                <img src="/assets/images/ui-uplift-icons/luca/how-to-use/info-bg-documents.jpg" alt="">
            </div>
            <div class="step-info-block card arrow-bottom">
                <div class="bot-logo">
                    <img src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
                </div>
                <div class="flexbox-column gap-4 step-right-block">
                    <h5 class="title">Drop your Docs with Luca</h5>
                    <div class="flexbox-column gap-8 right-block-inner">
                        <ul class="flexbox-column gap-4 ps-3">
                            <li>Upload documents from your desktop or the platform’s repository.</li>
                            <li>Supported file types: PDFs, Excel, Word, PNG.</li>
                            <li>Upload max 15 docs with a total size of 25MB.</li>
                        </ul>
                    </div>
                    <div class="button-group justify-content-end gap-8 mt-3">
                        <button mat-button mat-stroked-button color="dark" class="button-small" matStepperPrevious>Back</button>
                        <button mat-button mat-flat-button color="secondary" class="button-small" (click)="finish()">
                            Skip & Close
                        </button>
                        <button mat-button mat-flat-button color="primary" class="button-small" matStepperNext>Next</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step class="step-record">
        <ng-template matStepLabel>Simply Record your Query</ng-template>
        <div class="htu-step record">
            <div class="step-img-block">
                <img src="/assets/images/ui-uplift-icons/luca/how-to-use/info-bg-record.jpg" alt="">
            </div>
            <div class="step-info-block card arrow-right">
                <div class="bot-logo">
                    <img src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
                </div>
                <div class="flexbox-column gap-4 step-right-block">
                    <h5 class="title">Simply Record your Query</h5>
                    <div class="flexbox-column gap-8 right-block-inner">
                        <ul class="flexbox-column gap-4 ps-3">
                            <li>Record voice notes, and Luca converts them to text prompts.</li>
                            <li>Capture thoughts quickly, whether on the go or speaking.</li>
                            <li>Turn instructions into actionable steps within your workflow.</li>
                        </ul>
                    </div>
                    <div class="button-group justify-content-end gap-8 mt-3">
                        <button mat-button mat-stroked-button color="dark" class="button-small" matStepperPrevious>Back</button>
                        <button mat-button mat-flat-button color="secondary" class="button-small" (click)="finish()">
                            Skip & Close
                        </button>
                        <button mat-button mat-flat-button color="primary" class="button-small" matStepperNext>Next</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step class="step-context">
        <ng-template matStepLabel>Understanding Input & Output Units in LucaAI</ng-template>
        <div class="htu-step context">
            <div class="step-img-block">
                <img src="/assets/images/ui-uplift-icons/luca/how-to-use/info-bg-context.jpg" alt="">
            </div>
            <div class="step-info-block card arrow-right">
                <div class="bot-logo">
                    <img src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
                </div>
                <div class="flexbox-column gap-4 step-right-block">
                    <h5 class="title">Understanding Input & Output Units in LucaAI</h5>
                    <div class="flexbox-column gap-8 right-block-inner">
                        <p>Here’s how LucaAI works:</p>

                        <ul class="list-style-none flexbox-column gap-6 card p-2 mt-2">
                            <li class="flexbox-row gap-8 fs-16 ps-1 align-items-start">
                                <span class="dot-16 bg-primary mt-1">
                                    <i class="fa-regular fa-check fw-semibold"></i>
                                </span>
                                <span class="fs-14">
                                    <strong>Input Units:</strong> Data provided to Luca, like financial info or client docs. More relevant input improves results.
                                </span>
                            </li>
                            <li class="flexbox-row gap-8 fs-16 ps-1 align-items-start">
                                <span class="dot-16 bg-primary mt-1">
                                    <i class="fa-regular fa-check fw-semibold"></i>
                                </span>
                                <span class="fs-14">
                                    <strong>Output Units:</strong> Results from Luca, such as insights, working papers, or reports.
                                </span>
                            </li>
                            <li class="flexbox-row gap-8 fs-16 ps-1 align-items-start">
                                <span class="dot-16 bg-primary mt-1">
                                    <i class="fa-regular fa-check fw-semibold"></i>
                                </span>
                                <span class="fs-14">
                                    <strong>Unit Limit:</strong> Luca processes info within a set units limit, tracked in the context window..
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="button-group justify-content-end gap-8 mt-3">
                        <button mat-button mat-stroked-button color="dark" class="button-small" matStepperPrevious>Back</button>
                        <button mat-button mat-flat-button color="secondary" class="button-small" (click)="finish()">
                            Skip & Close
                        </button>
                        <button mat-button mat-flat-button color="primary" class="button-small" matStepperNext>Next</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step class="step-conversation">
        <ng-template matStepLabel>Engagement Driven Conversations</ng-template>
        <div class="htu-step conversation">
            <div class="step-img-block">
                <img src="/assets/images/ui-uplift-icons/luca/how-to-use/info-bg-conversation.jpg" alt="">
            </div>
            <div class="step-info-block card arrow-left">
                <div class="bot-logo">
                    <img src="/assets/images/ui-uplift-icons/luca/bot-new-logo.svg" alt="">
                </div>
                <div class="flexbox-column gap-4 step-right-block">
                    <h5 class="title">Engagement Driven Conversations</h5>
                    <div class="flexbox-column gap-8 right-block-inner">
                        <ul class="flexbox-column gap-4 ps-3">
                            <li>Easily access and search your conversations and documents in one place for a smooth workflow.</li>
                            <li>Report bugs, share feedback, or get help with a simple click.</li>
                            <li>Access this anytime by selecting "Help" from the "Support & Resources" section in your chat screen.</li>
                        </ul>
                    </div>
                    <div class="button-group justify-content-end gap-8 mt-3">
                        <button mat-button mat-stroked-button color="dark" class="button-small" matStepperPrevious>Back</button>
                        <button mat-button mat-flat-button color="primary" class="button-small" (click)="finish()">
                            <div class="flexbox-row gap-8">
                                <img src="/assets/images/ui-uplift-icons/luca/ai-logo-white-small.svg" alt="">
                                <span class="button-label">Let's Go</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>
  </mat-stepper>
